import * as React from 'react'
import {
  useGroupsFormStore,
  selectIsGroupSelected,
  type SelectedGroup,
} from '@/modules/drivers/stores/groupsFormStore'

export type { SelectedGroup }

export const useGroupsForm = () => {
  const store = useGroupsFormStore()
  const isSelected = React.useCallback(
    (id: number) => selectIsGroupSelected(id)(store),
    [store.selected],
  )
  return { ...store, isSelected }
}

export const GroupsFormProvider: React.FC<{
  children: React.ReactNode
  initialSelectedIds?: number[]
}> = ({ children, initialSelectedIds = [] }) => {
  const setSelected = useGroupsFormStore((s) => s.setSelected)
  const reset = useGroupsFormStore((s) => s.reset)

  React.useEffect(() => {
    setSelected(initialSelectedIds.map((id) => ({ id })))
    return () => { reset() }
  }, [])

  return <>{children}</>
}
